export default {
    primary: "#436BA2",
    highlight: "#7BA7DB",
    primaryLight: '#E4EDF7',
    primaryDark: "#223651",
    backgroundLightBlue: "#F1F6FB",
    backgroundLight: "#F1F6FB",
    textColored: "#1A1A36",
    "on-surface": "#343434",
    textMain: "#343434",
    textMainLight: "#55595A",
    error: "#B00020",
    info: "#2196F3",
    warning: "#FB8C00",
    yellow: "#FFCF00",
    amber: "#D78100",
    pink: "#F50077",
    orange: "#D14900",
    magenta: "#C33AFC",
    gray: "#909090",
    neutralgray: "#9BA6C1",
    green: "#195F00",
    red: "#FF5c4E",
    lightgray: "#BDBDBD",
    timelineGrey: "#ABABAB",
    lightpink: "#FFCFE3",
    white: "#FFFFFF",
    muted: "#F5F5F5",
    success: '#0FA12F',
    feeCalculatorTableBorder: '#EBEBEB',
    disabledButtonColour: '#767676',
};
